import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { COLOR_ADDITIONAL_WARM_GRAY_3U } from "~/theme/colors";
import { FontWeights } from "~/theme/typography";
import { getFormatMedia } from "~/theme/utils";

import { STORE_SERVICE_CLASSES } from "./constants";

export const StoreServiceContainer = styled(Box)(({ theme }) => {
  const { BREAKPOINT_TABLET } = getFormatMedia(theme);

  return {
    position: "relative",

    [`& .${STORE_SERVICE_CLASSES.link}`]: {
      zIndex: 1,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },

    [`& .${STORE_SERVICE_CLASSES.linkText}`]: {
      visibility: "hidden",
    },

    [`& .${STORE_SERVICE_CLASSES.serviceImage}`]: {
      height: 120,
      [BREAKPOINT_TABLET]: {
        height: "auto",
      },
    },

    [`& .${STORE_SERVICE_CLASSES.serviceInfoBlock}`]: {
      [theme.breakpoints.down(600)]: {
        padding: theme.spacing(2),
      },
      position: "relative",
      padding: theme.spacing(3),
      background: COLOR_ADDITIONAL_WARM_GRAY_3U,
    },

    [`& .${STORE_SERVICE_CLASSES.serviceDetailLink}`]: {
      zIndex: 1,
      textDecoration: "underline",
      lineHeight: "24px",
      position: "absolute",
      right: theme.spacing(3),
      top: theme.spacing(3),
      [theme.breakpoints.down(600)]: {
        right: theme.spacing(2),
        top: theme.spacing(2),
      },
    },

    [`& .${STORE_SERVICE_CLASSES.title}`]: {
      ...theme.typography.body1,
      fontWeight: FontWeights.fontWeightMedium,
      [BREAKPOINT_TABLET]: {
        ...theme.typography.h5,
      },
    },

    [`& .${STORE_SERVICE_CLASSES.subtitle}`]: {
      ...theme.typography.body2,
      [BREAKPOINT_TABLET]: {
        ...theme.typography.body1,
      },
    },
  };
});
